module.exports = __webpack_public_path__ + "img/9788961702751.2413c383.jpg";